import { render, staticRenderFns } from "./BikeDialogSetup.vue?vue&type=template&id=1a4e85e3&"
import script from "./BikeDialogSetup.vue?vue&type=script&lang=js&"
export * from "./BikeDialogSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports